/* eslint-disable */

const ActionCable = require("@rails/actioncable");

(function() {
  // Workaround to make the ActionCable beat interval longer.
  // The value below should be 2x the BEAT_INTERVAL value we have
  // in config/initializers/action_cable.rb.
  ActionCable.ConnectionMonitor.staleThreshold = 6;

  this.App || (this.App = {});
  this.App.cable = ActionCable.createConsumer();
}).call(window);
